import { render, staticRenderFns } from "./TwilioClient.vue?vue&type=template&id=a62ebd9a"
import script from "./TwilioClient.vue?vue&type=script&lang=js"
export * from "./TwilioClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports